<template>
<div>
    
 
  
  <div v-show="true" class="company-client" style="height:100%">
  
    <h4 class="alert alert-warning text-center" style="margin-top: 0px;">
    <span class="pre" v-text="companyClient.messageTextPre"></span>
    <strong class="short" v-text="companyClient.messageTextShort"></strong>
    <span class="post" v-text="companyClientMessageTextPost"></span>
    </h4>
    
    <div style="border-bottom: 1px solid #CCC;">
      <h2>
        <i class="fa fa-industry " aria-hidden="true"></i>{{companyClient.name}} - <small>{{companyClient.street}} {{companyClient.streetNumber}}, {{companyClient.zipCode}} {{companyClient.city}} ({{calledNumber}})</small>
      </h2>
    </div> 

     

    <div class="row" style="height: calc(100% - 120px)">

      <div class="col-xs-8" style="border-right: 1px solid #CCC; height:100%">
       <div class="cc-memo-list">
        <div class="panel-group" id="company-client-memo-accordion" role="tablist" aria-multiselectable="true">
          <cc-memo
            class="panel cc-panel-default cc-memo-item"
            v-for="(memo, index) in memos"
            :collapseIn="isMemoCollapse(index)"
            :data_parent="'company-client-memo-accordion'"
            :memo="memo"
            :key="memo.id" 
            @remove="onRemoveMemo"
            @update="onSetMemo">
          </cc-memo>
        </div>
      
        <div v-show="!memos.length" class="alert alert-warning" role="alert">Keine Vorgaben</div>

        <cc-memo 
          v-if="companyClient.id > 0"
          class="cc-kombox-item" 
          :idCompany="companyClient.id"
          :idUser="0"
          @insert="onAddMemo">
        </cc-memo>
      
      </div>
      </div>
     
      <div class="col-xs-4" style="height:100%">
        <!--<h4 class="text-center"></h4>-->
       <div class="cc-kombox-list">
         <cc-kombox 
            class="cc-kombox-item" 
            v-for="kombox in komboxes"
            :kombox="kombox"
            :key="kombox.id" 
            @add-shipping="onKomboxAddShipping"
            @remove-shipping="onKomboxRemoveShipping"
            @remove="onRemoveKombox"
            @update="onSetKombox">
         </cc-kombox>
         
         <div v-show="!komboxes.length" class="alert alert-warning" role="alert">Keine Komboxen</div>

         <cc-kombox 
            v-if="companyClient.id > 0"
            class="cc-kombox-item" 
            :idCompany="companyClient.id"
            :idUser="0"
            @insert="onAddKombox">
         </cc-kombox>

      </div>
      </div>
  
     </div>
          
  </div>            

    <company-client-start-modal v-if="startModal" @close="hideStartModal" @abort="abortStartModal">
      <div slot="body">
        <h1 class="alert alert-warning text-center" style="margin-top: 0px;">
          <span class="pre" v-text="companyClient.messageTextPre"></span>
          <strong class="short" v-text="companyClient.messageTextShort"></strong>
          <span class="post" v-text="companyClientMessageTextPost"></span>
        </h1>
      </div>
    </company-client-start-modal>
                                    
  </div>      
</template>



<script>

import Kombox from './Kombox.vue'
import Memo from './Memo.vue'
import bus from './common/bus'
import CompanyClientTypeahead from './CompanyClientTypeahead.vue'
import CompanyClientStartModal from './CompanyClientStartModal.vue'
import { ABORT_MODAL_TIMER } from './common/misc.conf.js'



export default {
    
  components: {
    'company-client-typeahead': CompanyClientTypeahead,
    'company-client-start-modal': CompanyClientStartModal,
    'cc-kombox': Kombox,
    'cc-memo': Memo,
  },
  
  data () {
    return {
      companyClient: {},         //bus.models.companyClient, // bus refrenz
      memos:[],
      komboxes:[],
      shippingIds: bus.shipping.idsCompanyClient, // bus refrenz
      startModal: false,
      abotModalTimer: null,
    }
  },
  
  created: function () {
    console.log('CompanyClient:created');
    bus.registerOnLogout(this.reset);
    bus.registerOnIdCompanyClient(this.onIdCompanyClient);
  },

  
  computed: {

    companyClientMessageTextPost: function () {
      var ret = this.companyClient.messageTextPost;
      if(typeof ret == "string"){
        ret = ret.replace(/<vname>/gi, bus.login.userCallCenter.firstName);
        ret = ret.replace(/<nname>/gi, bus.login.userCallCenter.lastName);
        ret = ret.replace(/<agent>/gi, bus.login.userCallCenter.firstName + ' ' + bus.login.userCallCenter.lastName);
      }
      return ret;
    },
    
    calledNumber: function() {
      return bus.call.calledNumber;
    },


  },
  
  methods: {
    
    isMemoCollapse: function (index) {
      // Todo: outsourcing Logic to 'MEMO' see also UserClient 
      
      if(this.memos[index].view == 'v'){
        return true // view
      }else if(this.memos[index].view == 'h'){
        return false // hide
      }else if(this.memos[index].typ == '0'){
        return true // 0 == Vorgabe immer öffnen
      }else{
        return (index == 0) // automatic open first
      }

    },

    
    onRemoveMemo: function (memo) {
      const indexOf = this.memos.indexOf(memo);
      if(indexOf != -1){
        this.memos.splice(indexOf, 1);
      }
    },
    
    onSetMemo: function (memo) {
      const indexOf = _.findIndex(this.memos, ['id', memo.id]);
      if(indexOf != -1){
        this.$set(this.memos, indexOf, memo);
      }
    },
    
    onAddMemo: function (memo) {
        this.memos.push(memo);
        this.memos = _.sortBy(this.memos, ['typ', 'sorting', 'datetimeBegin']);
    },
    
    onRemoveKombox: function (kombox) {
      const indexOf = this.komboxes.indexOf(kombox);
      if(indexOf != -1){
        this.komboxes.splice(indexOf, 1);
      }
    },
    
    onSetKombox: function (kombox) {
      // Note: kombox is a reference or a clone
      const indexOf = _.findIndex(this.komboxes, ['id', kombox.id]);
      if(indexOf != -1){
        this.$set(this.komboxes, indexOf, kombox);
      }
    },

    onAddKombox: function (kombox) {
        this.komboxes.push(kombox);
    },

    
    onKomboxAddShipping: function (kombox) {
      if(this.shippingIds.indexOf(kombox.id) == -1){
        this.shippingIds.push(kombox.id);
      }
    },

    onKomboxRemoveShipping: function (kombox) {
      this.shippingIds.splice(this.shippingIds.indexOf(kombox.id), 1);
    },
    

    onIdCompanyClient: function (idCompanyClient) {

      this.reset();

      if(idCompanyClient > 0){
        this.loadCompanyClient(idCompanyClient);
        this.loadMemos(idCompanyClient);
        this.loadKomboxes(idCompanyClient);
      }
    },
    
    reset: function () {
      // bus.resetCompanyClient(); // bus refrenz
      this.companyClient = {};
      
      this.memos = [];
      this.komboxes = [];
      this.shippingIds.splice(0 , this.shippingIds.length); // bus refrenz on this.shippingIds
      
    },
    
    showStartModal: function () {
      this.startModal = true;
    },
    
    hideStartModal: function () {
      // close Modal and call is working
      this.startModal = false;
      clearTimeout(this.abotModalTimer)
      this.$nextTick(function () {
          document.getElementById("caller-typeahead").focus();
      })
      
    },

    abortStartModal: function () {
      this.startModal = false;
      clearTimeout(this.abotModalTimer)  
      bus.callCancel();
    },
    
    loadCompanyClient: function (idCompanyClient) {
      
        // Zeige startmodal<
        this.showStartModal();
        this.abotModalTimer = setTimeout(this.abortStartModal, ABORT_MODAL_TIMER);

      this.$http.get(bus.config.path + '/company/client/' + idCompanyClient).then((response) => {
        //this.companyClient = _.assignIn(this.companyClient, response.data); // bus refrenz
        this.companyClient = response.data;

      
        bus.emitCompanyClient(this.companyClient);
      }, (response) => {
      // error callback
      });
    },

    loadMemos: function (idCompanyClient) {
      this.$http.get(bus.config.path + '/company/memos/' + idCompanyClient, {params: {typ: '01'}}).then((response) => {
        this.memos = _.sortBy(response.data, ['typ', 'sorting', 'datetimeBegin']);
        //console.log(response.data);

      }, (response) => {
      // error callback
      });
    },

    loadKomboxes: function (idCompanyClient) {
      this.$http.get(bus.config.path + '/company/komboxes/' + idCompanyClient).then((response) => {
        this.komboxes = response.data;
        //console.log(response.data);

      }, (response) => {
      // error callback
      });
    },
    
  }
  
}
</script>



<style scoped>
  
  
  .panel-group, .panel{
    margin-bottom: 0px;
  }  
  
h2 .fa {
    padding-right: 12px;
    color: #337ab7;
}
  

.cc-kombox-item{
    border-bottom: 1px solid lightgrey;
    padding-top: 5px;
    padding-bottom: 5px;
  
}  

.cc-kombox-item:hover,
.cc-memo-item:hover{
  background-color: #fcf8e3;
}

.cc-kombox-list, 
.cc-memo-list{
    height: 100%;
    overflow: auto;
}
  
  
</style>



// WEBPACK FOOTER //
// CompanyClient.vue?0622a050